import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  attributeTypeFeatureKey,
  AttributeTypeState,
} from './attribute-type-reducer';

export const getFilterAttributeTypeState =
  createFeatureSelector<AttributeTypeState>(attributeTypeFeatureKey);

export const getAttributeTypeState = createSelector(
  getFilterAttributeTypeState,
  (state: AttributeTypeState) => state
);
